function normalizeText(value = "") {
  return String(value || "").replace(/\s+/g, " ").trim();
}

export function buildCompletionPersistenceFailureMessage(correlationId = "") {
  const reference = normalizeText(correlationId) || "unavailable";
  return `I couldn’t complete this session because the completion record was not saved. The session is still active. Correlation ID: ${reference}.`;
}

export function resolveCompletionAssistantText({
  sessionCompleted = false,
  persistenceSucceeded = false,
  successText = "",
  ordinaryText = "",
  correlationId = "",
} = {}) {
  if (!sessionCompleted) return normalizeText(ordinaryText);
  if (persistenceSucceeded) return normalizeText(successText);
  return buildCompletionPersistenceFailureMessage(correlationId);
}
